import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  methods: {
    async rekapitulasiPerInstansi(val, opsi) {
      const dataReport = await this.loadReportPerInstansi(val, opsi);
      const dataShow = dataReport?.map((data) => {
        return [
          {
            text: data.kodeBidangObrik,
            fontSize: 8,
            // margin: [10, 0],
          },
          {
            text: data.bidangObrik,
            fontSize: 8,
            // margin: [10, 0],
          },
          {
            text: data.jumlahTemuan,
          },
          {
            text: this.$func.convertToRupiah(data.totalNilaiTemuan),
          },
          {
            text: data.jumlahRekomendasi,
          },
          {
            text: this.$func.convertToRupiah(data.totalNilaiRekomendasi),
          },
          {
            text: data.jumlahTl,
          },
          {
            text: this.$func.convertToRupiah(data.totalNilaiTl),
          },
          {
            text: this.$func.convertToRupiah(data.totalSaldo),
          },
        ];
      });
      const repDummy = [];
      for (let i = 0; i < 50; i++) {
        repDummy.push([
          {
            text: "SEKRETARIAT DAERAH KABUPATEN",
            fontSize: 8,
            margin: [10, 0],
          },
          {
            text: "12",
          },
          {
            text: "Rp. 10,900,000,000.00",
          },
          {
            text: "12",
          },
          {
            text: "Rp. 10,900,000,000.00",
          },
          {
            text: "12",
          },
          {
            text: "Rp. 10,900,000,000.00",
          },
          {
            text: "Rp. 10,900,000,000.00",
          },
        ]);
      }
      const docDef = {
        pageSize: "A4",
        pageOrientation: "landscape",
        pageMargins: [17, 85, 17, 30],
        header: [
          {
            text: localStorage.namaUnit,
            fontSize: 14,
            bold: true,
            margin: [17, 20, 0, 3],
          },
          {
            text: "Rekapitulasi Temuan dan Tindaklanjut",
            fontSize: 13,
            margin: [17, 0, 0, 0],
          },
          {
            text:
              "Periode Pelaporan " + opsi.dateMulai.toLocaleDateString("id"),
            fontSize: 8,
            style: "headerPeriod",
            margin: [0, 0, 17, 3],
          },
          {
            text: "sd. " + opsi.dateSelesai.toLocaleDateString("id"),
            fontSize: 8,
            margin: [0, 0, 17, 7],
            style: "headerPeriod",
          },
        ],
        footer: function (currentPage, pageCount) {
          return {
            columns: [
              {
                text: "Tanggal Cetak : " + new Date().toLocaleString("id"),
                margin: [17, 0, 0, 0],
                fontSize: 7,
              },
              {
                text:
                  "halaman ke " + currentPage.toString() + " dari " + pageCount,
                alignment: "right",
                margin: [0, 0, 40, 0],
                fontSize: 7,
              },
            ],
          };
        },
        content: [
          {
            style: "tableExample",
            color: "#444",
            fontSize: 6,
            table: {
              widths: [100, 300, 19, 70, 19, 70, 19, 70, 75],
              headerRows: 2,
              // keepWithHeaderRows: 1,
              body: [
                [
                  {
                    text: "KODE BIDANG OBRIK",
                    style: "tableHeader",
                    rowSpan: 2,
                    border: [false, true, false, true],
                  },
                  {
                    text: "NAMA BIDANG OBRIK",
                    style: "tableHeader",
                    rowSpan: 2,
                    border: [false, true, false, true],
                  },
                  {
                    text: "TEMUAN",
                    style: "tableHeader",
                    colSpan: 2,
                    border: [false, true, false, false],
                  },
                  {},
                  {
                    text: "REKOMENDASI",
                    style: "tableHeader",
                    colSpan: 2,
                    border: [false, true, false, false],
                  },
                  {},
                  {
                    text: "TINDAK LANJUT",
                    style: "tableHeader",
                    colSpan: 2,
                    border: [false, true, false, false],
                  },
                  {},
                  {
                    text: "SALDO",
                    style: "tableHeader",
                    border: [false, true, false, false],
                  },
                ],
                [
                  {},
                  {},
                  {
                    text: "#Kej.",
                    style: "tableSubHeader",
                    border: [false, false, false, true],
                  },
                  {
                    text: "Nilai Rp.",
                    style: "tableSubHeader",
                    border: [false, false, false, true],
                  },
                  {
                    text: "#Kej.",
                    style: "tableSubHeader",
                    border: [false, false, false, true],
                  },
                  {
                    text: "Nilai Rp.",
                    style: "tableSubHeader",
                    border: [false, false, false, true],
                  },
                  {
                    text: "#Kej.",
                    style: "tableSubHeader",
                    border: [false, false, false, true],
                  },
                  {
                    text: "Nilai Rp.",
                    style: "tableSubHeader",
                    border: [false, false, false, true],
                  },
                  {
                    text: "Nilai Rp.",
                    style: "tableSubHeader",
                    border: [false, false, false, true],
                  },
                ],
                ...dataShow,
                // ...repDummy,
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === 2 ? 1.5 : 0.5;
              },
              vLineWidth: function (i, node) {
                return 0;
              },
              fillColor: function (rowIndex, node, columnIndex) {
                return rowIndex % 3 === 0 && rowIndex > 1 ? "#eeeeee" : null;
              },
              // hLineColor: function (i, node) {
              //   return i === 0 || i === node.table.body.length
              //     ? 'black'
              //     : 'gray';
              // },
              // vLineColor: function (i, node) {
              //   return i === 0 || i === node.table.widths.length
              //     ? 'black'
              //     : 'gray';
              // },
              // hLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
              // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
              // paddingLeft: function (i, node) {
              //   return 20;
              // },
              // paddingRight: function(i, node) { return 4; },
              paddingTop: function (i, node) {
                return 4;
              },
              paddingBottom: function (i, node) {
                return 4;
              },
              // fillColor: function (rowIndex, node, columnIndex) { return null; }
            },
          },
        ],
        styles: {
          headerPeriod: {
            alignment: "right",
          },
          tableHeader: {
            // alignment: "center",
            fontSize: 8,
          },
          tableSubHeader: {
            alignment: "left",
            fontSize: 8,
            bold: true,
          },
        },
      };
      pdfMake.createPdf(docDef).open();
    },

    async loadReportPerInstansi(val, opsi) {
      try {
        const response = await axios({
          method: "GET",
          baseURL: this.$apiAddress,
          url: val.endpoint,
          params: {
            token: localStorage.getItem("api_token"),
            fromDate: opsi.dateMulai.toLocaleDateString("fr-CA"),
            toDate: opsi.dateSelesai.toLocaleDateString("fr-CA"),
          },
        });
        if (response.status == 200) {
          const responseData = await response.data;
          const repData = [];

          for (const key in responseData) {
            const data = {
              kodeBidangObrik: responseData[key]["Kode_Bidang_Obrik"],
              bidangObrik: responseData[key]["Bidang_Obrik"],
              jumlahTemuan: responseData[key]["Jumlah_Temuan"],
              totalNilaiTemuan: responseData[key]["Total_Nilai_Temuan"],
              jumlahRekomendasi: responseData[key]["Jumlah_Rekomendasi"],
              totalNilaiRekomendasi:
                responseData[key]["Total_Nilai_Rekomendasi"],
              jumlahTl: responseData[key]["Jumlah_Tindak_Lanjut"],
              totalNilaiTl: responseData[key]["Total_Nilai_Tindak_Lanjut"],
              totalSaldo: responseData[key]["Total_Saldo_Nilai_Temuan"],
            };
            repData.push(data);
          }

          // console.log("--> DATAAA :: ");
          // console.log(repData);

          return repData;
        }
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
